import React, { useState } from "react";

import FormFilter from "../filter";
import { PlusOutlined } from "@ant-design/icons";

import { PageHeader, Descriptions, Divider, Row, Col, Button, Table, Tag, Switch, Space, DatePicker } from "antd";
import ResponsiveChart from "./chart";
import DataTable from "./table";

const { RangePicker } = DatePicker;

const Show = (props) => {
    const goBack = () => props.history.goBack();

    const [chartType, setChartType] = useState("Line");
    const [brush, setBrush] = useState(true);
    const [displayTable, setDisplayTable] = useState(true);

    const [data, setData] = useState(props.periodList || []);
    const [variables, setVariables] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    const isModalActive = modalVisible;

    const onChangeBrush = (algo) => {
        setBrush(!brush);
    };

    const onChangeDisplayTable = (algo) => {
        setDisplayTable(!displayTable);
    };

    const onChangeChartStyle = (value) => {
        if (value) {
            setChartType("Line");
        } else {
            setChartType("Bar");
        }
    };

    const getTooltip = (variableKey, periodId) => {
        let periodIndex = null;
        for (const [key, value] of Object.entries(props.periodList)) {
            if (value.id === periodId) {
                periodIndex = key;
            }
        }

        const found = variables.find((element) => {
            return element.key === variableKey;
        });

        if (found && periodIndex) {
            const total = found.totales[periodIndex];
            const totalUnit = found.totalUnit ? ` ${found.totalUnit}` : "";
            return ` (${total.toString()}${totalUnit})`;
        }

        return "";
    };

    const updateData = (result) => {
        const retKey = result["key"] ?? "";
        const retName = result["display_name"] ?? "";
        const retColor = result["color"] ?? "";
        const retValues = result["values"] ?? [];
        const retUnit = result["unit"] ?? "";
        const retTotales = result["total"] ?? [];
        const retTotalUnit = result["total_unit"] ?? "";

        const newVariables = variables.concat({
            key: retKey,
            name: retName,
            color: retColor,
            totales: retTotales,
            totalUnit: retTotalUnit,
            unit: retUnit,
        });
        const newData = [];

        for (const [key, value] of Object.entries(data)) {
            newData[key] = { ...value, [retKey]: retValues[key] ?? null, [`${retKey}_total`]: retTotales[key] ?? 0 };
        }

        setVariables(newVariables);
        setData(newData);
    };

    const removeData = (e, removedKey) => {
        e.preventDefault();

        const newVariables = variables.filter((item) => item.key !== removedKey);
        const newData = [];

        for (const [key, value] of Object.entries(data)) {
            const newValue = { ...value };
            delete newValue[removedKey];
            newData[key] = newValue;
        }

        setVariables(newVariables);
        setData(newData);
    };

    return (
        <>
            {props.periodList && (
                <PageHeader
                    ghost={false}
                    title="Evolution by periods"
                    subTitle="Stats"
                    extra={[
                        <Space key="switches">
                            <Switch
                                key="displayTable"
                                size="small"
                                defaultChecked
                                onChange={onChangeDisplayTable}
                                checkedChildren="Table"
                                unCheckedChildren="Table"
                            />
                            <Switch
                                key="chartStyle"
                                size="small"
                                defaultChecked
                                onChange={onChangeChartStyle}
                                checkedChildren="Line"
                                unCheckedChildren="Bar"
                            />
                            <Switch
                                key="brush"
                                size="small"
                                defaultChecked={brush}
                                onChange={onChangeBrush}
                                checkedChildren="Brush"
                                unCheckedChildren="Brush"
                            />
                        </Space>,
                    ]}
                >
                    <Space direction="vertical">
                        <Space wrap>
                            {(variables || []).map((item) => (
                                <Tag
                                    key={item.key}
                                    closable
                                    onClose={(e) => removeData(e, item.key)}
                                    color={item?.color}
                                >
                                    {item.name}
                                </Tag>
                            ))}

                            <Tag
                                className="site-tag-plus"
                                onClick={() => setModalVisible(true)}
                                disabled={isModalActive}
                                style={{ background: "#fff", borderStyle: "dashed" }}
                            >
                                <PlusOutlined /> New variable
                            </Tag>
                        </Space>
                    </Space>

                    <ResponsiveChart
                        chartType={chartType}
                        data={data}
                        variables={variables}
                        brush={brush}
                        result={props.periodListQuery.result}
                        getTooltip={getTooltip}
                    />

                    <Divider />

                    {displayTable && (
                        <DataTable
                            data={data || []}
                            variables={variables || []}
                            result={props.periodListQuery.result}
                        />
                    )}

                    {modalVisible && (
                        <FormFilter
                            visible={modalVisible}
                            updateData={updateData}
                            handleCancel={() => {
                                setModalVisible(false);
                            }}
                            id={1}
                            periodListQuery={props.periodListQuery}
                            result={props.periodListQuery.result}
                            {...props}
                        />
                    )}

                    <Divider />
                </PageHeader>
            )}
        </>
    );
};

export default Show;

/**
    <div style={{ width: '100%', height: 300 }}>

        <ResponsiveContainer>
      <ComposedChart
        width={500}
        height={300}
        data={data.stats}
        margin={{
          top: 20, right: 30, left: 20, bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="pv" stackId="a" fill="#8884d8" />
        <Bar dataKey="uv" stackId="a" fill="#82ca9d" />
            <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
      </ComposedChart>

            </ResponsiveContainer>
        </div>
*/
